import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_LOCATIONS = "GET_ALL_LOCATIONS";
export const GET_LOCATION = "GET_LOCATION";
export const CALOCA_LOADING = "CALOCA_LOADING";
export const ADD_LOCATION = "ADD_LOCATION";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllLocations = () => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CALOCA_LOADING
    });
    await instance.get(`/Locations/GetAllLocations/${Token}`).then((res => {
        dispatch({
            type: GET_ALL_LOCATIONS,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetLocationById = (id) => {
  var Token = convertSHA()
  return async dispatch => {
    dispatch({
      type: CALOCA_LOADING
    });
    await instance.get(`/Locations/GetLocationsById/${id}&${Token}`).then((res => {
        dispatch({
            type: GET_LOCATION,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const addLocation = data =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: CALOCA_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/Locations/PutInsUpdtLocation/${data.id}&${data.name}&${data.active}&${data.modified_By}&${Token}` ).then((res => {
            dispatch({
                type: ADD_LOCATION,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
